import { Injectable } from '@angular/core';
import { TransactionError, TransactionService } from './transaction.service';
import { SocketService } from './socket.service';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(
    private transactionService: TransactionService,
    private socketService: SocketService
  ) { }

  invite(device) {
    if (!device.usable) {
      return Promise.reject(new Error('Device is not usable'))
    }

    let tx: any = this.transactionService.create(device)
    this.socketService.socket.emit('group.invite', device.channel, tx.channel, {
      requirements: {
        serial: {
          value: device.serial
        , match: 'exact'
        }
      }
    })
    return tx.promise
      .then((result) => {
        return result.device
      })
      .catch(TransactionError,() => {
        throw new Error('Device refused to join the group')
      })
  }

  kick(device, force? :any) {
    if (!force && !device.usable) {
      return Promise.reject(new Error('Device is not usable'))
    }
    
    let tx = this.transactionService.create(device) as any;
    
    
    this.socketService.socket.emit('group.kick', device.channel, tx.channel, {
      requirements: {
        serial: {
          value: device.serial
        , match: 'exact'
        }
      }
    })
    return tx.promise
      .then(function(result) {
        return result.device
      })
      .catch(TransactionError, function() {
        throw new Error('Device refused to join the group')
      })
  }
}
